import { Newspaper, Download } from 'lucide-react';
import MarketingLayout from './_layout';

const releases = [
  {
    date: '2026-04-02',
    title: 'Messego launches AI copilots across messaging, commerce, and career modules',
    excerpt: 'A unified copilot drafts replies, surfaces leads, and recommends candidates without leaving the inbox.',
  },
  {
    date: '2026-01-15',
    title: 'Messego crosses 10,000 companies on the platform',
    excerpt: 'From early-stage startups to Fortune 500 enterprises, businesses are consolidating their professional toolchain on Messego.',
  },
  {
    date: '2025-09-08',
    title: 'Messego raises Series C to expand internationally',
    excerpt: 'New funding accelerates expansion into Latin America, Southeast Asia, and the Middle East.',
  },
];

const contacts = [
  { label: 'Press inquiries', value: 'press@messego.com' },
  { label: 'Partnerships', value: 'partnerships@messego.com' },
];

export default function PressPage() {
  return (
    <MarketingLayout
      title="Press & news"
      subtitle="The latest announcements, milestones, and brand assets from the Messego team."
    >
      <section className="space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {contacts.map((c, i) => (
            <div key={i} className="p-6 bg-neutral-50 dark:bg-neutral-950 rounded-2xl border border-neutral-200 dark:border-neutral-800 space-y-1">
              <p className="text-xs uppercase tracking-wider text-neutral-500 dark:text-neutral-400 font-bold">{c.label}</p>
              <p className="font-mono text-sm">{c.value}</p>
            </div>
          ))}
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-bold">Recent announcements</h2>
          <div className="space-y-4">
            {releases.map((r, i) => (
              <article key={i} className="p-6 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-2xl space-y-2">
                <div className="flex items-center gap-2 text-xs text-neutral-400 dark:text-neutral-500">
                  <Newspaper size={12} />
                  <time>{r.date}</time>
                </div>
                <h3 className="font-bold text-lg text-neutral-900 dark:text-neutral-50">{r.title}</h3>
                <p className="text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">{r.excerpt}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="p-8 bg-neutral-900 text-white rounded-[2rem] flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="space-y-2">
            <h3 className="text-xl font-bold">Brand assets</h3>
            <p className="text-sm text-neutral-300">Logos, wordmarks, and product screenshots in print-ready formats.</p>
          </div>
          <button className="inline-flex items-center gap-2 bg-white dark:bg-neutral-900 text-neutral-900 dark:text-neutral-50 px-5 py-3 rounded-xl font-bold text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800">
            <Download size={16} /> Download press kit
          </button>
        </div>
      </section>
    </MarketingLayout>
  );
}
